<template>
    <div class="px-3 py-2">
        <v-form
            ref="forcar"
            lazy-validation
            autocomplete="off"
        >
            <b-sidebar id="send_whats" aria-labelledby="sidebar-no-header-title" no-header backdrop width="850px" style="direction:ltr" right title="إضافة ملاحظة" shadow >
                <template #default="{ hide }">
                    <div class="m-1 text-start" style="direction:rtl">
                        <div style="width:140px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                            <span>ارسال واتس اب</span>
                        </div>
                        <div @click="hide" id="hideaddHomeTaskss" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
                            <span>{{ lang.close }}</span>
                        </div>
                    </div>
                    <v-divider></v-divider>
                    <v-row style="direction:rtl" class="m-2">
                        <v-col cols="12" md="12">
                            <label>اختر القالب</label>
                            <b-form-select class="selborder" v-model="templateId" :options="TemplatesIds" />
                        </v-col>
                        
                        
                        <v-col cols="12" md="12">
                            <v-row>
                                <v-col cols="12" md="6" v-for="(item,index) in templateVars" :key="index">
                                    <label>{{ item.var_label }}</label>
                                    <b-form-input class="inborder" v-model="item.var_value" />
                                </v-col>
                                
                            </v-row>
                        </v-col>
                    </v-row>
                </template>
                <template #footer="">
                    <div class="d-flex text-light align-items-center px-3 py-2">
                        <b-button type="button" @click="addJob()" variant="success" class="ma-2" style="width:100px;">ارسل</b-button>
                    </div>
                </template>
            </b-sidebar>
        </v-form>
        <vue-snotify></vue-snotify>
    </div>
</template>

<script>
import axios from 'axios'
import {SnotifyPosition} from 'vue-snotify'
export default{
    data() {
        return {
            showConvertedTo: false,
            templateVars: [],
            customers: []
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }else{
                return this.$store.state.lang.ar;
            }
        },
    },
    methods: {
        
        addJob(){
            let message = '';
            let co = true;
            if(this.customer.mobile == "" || this.customer.company_name == '' || this.customer.full_name == ''){
                message = this.lang.customer_require
                co = false;
            }
            else if(this.support.subject == ""){
                message = this.lang.subject_require
                co = false;
            }
            
            else if(this.support.executed_date_start === ""){
                message = this.lang.executed_date_require
                co = false;
                console.log(this.support.executed_date_start)
            }
            
            else if(this.support.notes === ""){
                message = this.lang.notes_require
                co = false;
            }
            else if(this.support.times.length === 0){
                message = this.lang.times_require
                co = false;
            }
            else if(this.customer.industrial.trim() == ''){
                message = "الصناعية مطلوبة دائما - يمكن اضافة اسم المدينة اذا كانت خارج الرياض"
                co = false;
            }
            
            if(!co) {
                this.$snotify.error(message, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close, 
                            action: (toast) => {
                                this.$snotify.remove(toast.id); 
                            } 
                        },
                    ]
                });
                return false;
            }
            
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getWhatsTemplates")
            post.append("auth",this.$cookies.get(this.$COOKIEPhase))
            post.append(`data[active]`,"1")

            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => { 
                this.TemplatesIds = response.data.results.data;
            });
        },
        getTemplates()
        {
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getWhatsTemplates")
            post.append("auth",this.$cookies.get(this.$COOKIEPhase))
            post.append(`data[active]`,"1")

            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => { 
                this.TemplatesIds = response.data.results.data;
            });
        },
        getTemplateVars()
        {
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getTemplateVars")
            post.append("auth",this.$cookies.get(this.$COOKIEPhase))
            post.append(`data[templateId]`,this.templateId)

            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => { 
                this.templateVars = response.data.results.data;
            });
        }
    },
    created() {
        this.getTemplates()
    },
}
</script>
<style scoped>
.itemSel{
    margin:2px;
    color:#fff;
    text-align: center;
    padding:5px;
    cursor: pointer;
}
</style>